export default __webpack_public_path__ + "static/media/mob3.3c127bb9.jpg";